import { IUser } from '../../interfaces/IUser';

export const getAdaptedUser = (userResponseData: IUser): IUser => {
	return {
		id: userResponseData.id,
		auid: userResponseData.auid,
		email: userResponseData.email,
		isMyDeleted: userResponseData.isMyDeleted,
		avatar: {
			changeTime: userResponseData.avatar?.changeTime || null, // показывает верный аватар при смене юезров (иначе мешает кэш)
			url: {
				size180: userResponseData.avatar?.url?.size180 || null,
				size45: userResponseData.avatar?.url?.size45 || null,
				size32: userResponseData.avatar?.url?.size32 || null,
				size600: userResponseData.avatar?.url?.size600 || null,
				size90: userResponseData.avatar?.url?.size90 || null,
			},
		},
		name: {
			first: userResponseData.name?.first || '',
			last: userResponseData.name?.last || '',
			full: userResponseData.name?.full || '',
		},
		isFemale: userResponseData.isFemale || null,
		age: userResponseData.age || 0,
		createTime: userResponseData.createTime || null,
		isMyCreated: userResponseData.isMyCreated || null,
		isVip: userResponseData.isVip || null,
		isAdvFree: userResponseData.isAdvFree || null,
		locale: userResponseData.locale || null,
		dir: userResponseData.dir || null,
		count: {
			friends: userResponseData.count?.friends || null,
			follows: userResponseData.count?.follows || null,
		},
		timezone: userResponseData.timezone || null,
		isOldVerified: userResponseData.isOldVerified || null,
		sumMailiki: userResponseData.sumMailiki || null,
		isShowAge: userResponseData.isShowAge || null,
		isInSandbox: userResponseData.isAdvFree || null,
		isNeedVerify: userResponseData.isNeedVerify || null,
		magicNumber: {
			a: userResponseData.magicNumber?.a || null,
			b: userResponseData.magicNumber?.b || null,
		},
		isAdmin: userResponseData.isAdvFree || null,
	};
};
